<template>
  <jd-tooltip
    ref="tooltipRef"
    trigger="click"
    effect="light"
    v-bind="$attrs"
    :popper-class="`${ns.namespace.value}-popover`"
    :popper-style="style"
    :teleported="teleported"
    :placement="placement"
    :fallback-placements="fallbackPlacements"
    :hide-after="hideAfter"
    :persistent="persistent"
  >
    <template #content>
      <div :class="ns.b()">
        <div :class="ns.e('main')">
          <jd-icon
            v-if="!hideIcon && icon"
            :class="ns.e('icon')"
            :style="{ color: iconColor }"
          >
            <component :is="icon" />
          </jd-icon>
          {{ title }}
        </div>
        <div :class="ns.e('action')">
          <jd-button
            v-if="!hideConfirmButton"
            size="small"
            :type="confirmButtonType"
            data-component-name="PopConfirm"
            data-event-name="popconfirm-confirm"
            data-event-content="确认按钮"
            @click="confirm"
          >
            {{ finalConfirmButtonText }}
          </jd-button>
          <jd-button
            v-if="!hideCancelButton"
            size="small"
            :type="cancelButtonType === 'plain' ? '' : cancelButtonType"
            :plain="cancelButtonType === 'plain'"
            data-component-name="PopConfirm"
            data-event-name="popconfirm-cancel"
            data-event-content="取消按钮"
            @click="cancel"
          >
            {{ finalCancelButtonText }}
          </jd-button>
        </div>
      </div>
    </template>
    <template v-if="$slots.reference">
      <span
        data-component-name="PopConfirm"
        data-event-name="popconfirm-trigger"
        data-event-content="气泡确认框触发"
      >
        <slot name="reference" />
      </span>
    </template>
  </jd-tooltip>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import JdButton from '@jdesign-vue/components/button'
import JdIcon from '@jdesign-vue/components/icon'
import JdTooltip from '@jdesign-vue/components/tooltip'
import { useLocale, useNamespace } from '@jdesign-vue/hooks'
import { addUnit } from '@jdesign-vue/utils'
import { popconfirmEmits, popconfirmProps } from './popconfirm'

import type { TooltipInstance } from '@jdesign-vue/components/tooltip'

defineOptions({
  name: 'JdPopconfirm',
})

const props = defineProps(popconfirmProps)
const emit = defineEmits(popconfirmEmits)

const { t } = useLocale()
const ns = useNamespace('popconfirm')
const tooltipRef = ref<TooltipInstance>()

const hidePopper = () => {
  tooltipRef.value?.onClose?.()
}

const style = computed(() => {
  return {
    width: addUnit(props.width),
  }
})

const confirm = (e: MouseEvent) => {
  emit('confirm', e)
  hidePopper()
}
const cancel = (e: MouseEvent) => {
  emit('cancel', e)
  hidePopper()
}

const finalConfirmButtonText = computed(
  () => props.confirmButtonText || t('el.popconfirm.confirmButtonText')
)
const finalCancelButtonText = computed(
  () => props.cancelButtonText || t('el.popconfirm.cancelButtonText')
)
</script>
